import { useCallback, useRef, useState } from 'react';
import type { Dispatch, MutableRefObject, SetStateAction } from 'react';
import type { AnimationPlaybackControls } from 'framer-motion';
import type { DisplayLine } from './Cbullshitcoding.typing';

export interface CbullshitcodingTypingState {
  completedLines: DisplayLine[];
  currentLineIndex: number;
  currentTypingLine: string;
  controlsRef: MutableRefObject<AnimationPlaybackControls | undefined>;
  hasContentRef: MutableRefObject<boolean>;
  setCompletedLines: Dispatch<SetStateAction<DisplayLine[]>>;
  setCurrentLineIndex: Dispatch<SetStateAction<number>>;
  setCurrentTypingLine: Dispatch<SetStateAction<string>>;
  stringIndexRef: MutableRefObject<number>;
  timeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | undefined>;
  resetTypingState: () => void;
}

export function useCbullshitcodingTypingState(): CbullshitcodingTypingState {
  const [completedLines, setCompletedLines] = useState<DisplayLine[]>([]);
  const [currentTypingLine, setCurrentTypingLine] = useState('');
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const stringIndexRef = useRef(0);
  const controlsRef = useRef<AnimationPlaybackControls | undefined>(undefined);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const hasContentRef = useRef(false);

  const resetTypingState = useCallback((): void => {
    setCompletedLines([]);
    setCurrentTypingLine('');
    stringIndexRef.current = 0;
  }, []);

  return {
    completedLines,
    currentLineIndex,
    currentTypingLine,
    controlsRef,
    hasContentRef,
    setCompletedLines,
    setCurrentLineIndex,
    setCurrentTypingLine,
    stringIndexRef,
    timeoutRef,
    resetTypingState,
  };
}
